<template>
    <v-card v-if="user_data" :class="[$style.userFormMain, {[$style.userFormMainFr]: $language() == 'fr'}]" width="80%" flat>
        <v-form 
            ref="userFormRegister" 
            v-model="valid.userForm" 
            v-on:submit.prevent="validateRegister"
            >

            <v-container fluid pa-0 id="sign-up-container">
                <v-layout row wrap :justify-space-around="$language() == 'en'" :justify-space-between="$language() == 'fr'">                   
                    <!-- Firstname -->
                    <v-flex xs12 sm5>
                        <p :class="$style.registerLabel">
                            <str index="form > firstname"/><sup>*</sup>
                        </p>
                        <v-text-field 
                            @keyup="proper('user_data.firstname' , user_data.firstname)" 
                            :class="['registerInput',$style.inputField]" 
                            outlined 
                            v-model='user_data.firstname' 
                            :rules="formRules().validFirstName"
                            background-color="white"
                            required
                            dense>
                            <template v-slot:message="{ message }">
                                <str :index="message" />
                            </template>
                        </v-text-field>
                    </v-flex>

                    <!-- Lastname -->
                    <v-flex xs12 sm5>
                        <p :class="$style.registerLabel">
                            <str index="form > lastname"/><sup>*</sup>
                        </p>
                        <v-text-field 
                            @keyup="proper('user_data.lastname' , user_data.lastname)" 
                            :class="['registerInput',$style.inputField]" 
                            outlined 
                            v-model='user_data.lastname' 
                            :rules="formRules().validLastName"
                            background-color="white"
                            required>
                            <template v-slot:message="{ message }">
                                <str :index="message" />
                            </template>
                        </v-text-field>
                    </v-flex>

                    <!-- Country -->
                    <v-flex xs12 sm5>
                        <p :class="$style.registerLabel">
                            <str index="form > country"/><sup>*</sup>
                        </p>

                        <v-autocomplete 
                            :class="['registerInput',$style.inputField]" 
                            :items="list_countries" 
                            v-model="user_data.country"
                            :rules="formRules().validCountry"
                            background-color="white"
                            dense
                            outlined>
                            <template v-slot:message="{ message }">
                                <str :index="message" />
                            </template>
                        </v-autocomplete>
                    </v-flex>

                    <!-- Province / States -->
                    <v-flex xs12 sm5>
                        <p :class="$style.registerLabel">
                            <str index="form > province"/><sup>*</sup>
                        </p>
                        <v-autocomplete 
                            :class="['registerInput',$style.inputField]" 
                            :items="list_states" 
                            item-text="text"
                            item-value="value"
                            v-model="user_data.province"
                            :rules="formRules().validProvinceState"
                            background-color="white"
                            :disabled="!user_data.country"
                            dense
                            outlined>
                            <template v-slot:message="{ message }">
                                <str :index="message" />
                            </template>
                        </v-autocomplete>                    
                    </v-flex>

                    <!-- City -->
                    <v-flex xs12 sm5>
                        <p :class="$style.registerLabel">
                            <str index="form > city"/><sup>*</sup>
                        </p>
                        <v-text-field 
                            @keyup="proper('user_data.city' , user_data.city)" 
                            :class="['registerInput',$style.inputField]" 
                            :rules="formRules().validCity"
                            outlined 
                            dense
                            background-color="white"
                            v-model='user_data.city' 
                            required>
                            <template v-slot:message="{ message }">
                                <str :index="message" />
                            </template>
                        </v-text-field>
                    </v-flex>
                    
                    <v-flex sm5 v-if="$vuetify.breakpoint.smAndUp">
                        <v-spacer/>
                    </v-flex>
                                    
                    <!-- HCP Job Profession -->
                    <v-flex xs12 :sm5="$language() == 'en'" :sm8="$language() == 'fr'">
                        <p :class="$style.registerLabel">
                            <str index="form > hcp_job_profession"/><sup>*</sup>
                        </p>
                        <v-autocomplete 
                            :class="['registerInput',$style.inputField]" 
                            :items="list_hcp_job_profession" 
                            v-model="user_data.hcp_job_profession"
                            :rules="formRules().validHcpJobProfession"
                            background-color="white"
                            dense
                            outlined>
                            <template v-slot:message="{ message }">
                                <str :index="message" />
                            </template>
                            <template slot="selection" slot-scope="data" dense>
                                <!-- HTML that describe how select should render selected items -->
                                {{data.item.text}}
                            </template>

                            <template v-slot:item="{ item }">
                                <v-list-item-content dense>
                                    <!-- HTML that describe how select should render items when the select is open -->
                                    <v-list-item-title>
                                        {{item.text}}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                    </v-flex>   
                    
                    <!-- Specialty Input -->
                    <v-flex xs12 :sm5="$language() == 'en'" :sm8="$language() == 'fr'">
                        <p :class="$style.registerLabel">
                            <str index="form > specialty"/><sup>*</sup>
                        </p>
                        <v-autocomplete 
                            :class="['registerInput',$style.inputField]" 
                            :items="list_specialty" 
                            v-model="user_data.specialty"
                            :rules="formRules().validSpecialty"
                            background-color="white"
                            dense
                            outlined>
                            <template v-slot:message="{ message }">
                                <str :index="message" />
                            </template>
                            <template slot="selection" slot-scope="data" dense>
                                <!-- HTML that describe how select should render selected items -->
                                {{data.item.text}}
                            </template>

                            <template v-slot:item="{ item }">
                                <v-list-item-content dense>
                                    <!-- HTML that describe how select should render items when the select is open -->
                                    <v-list-item-title :class="[{'specialtyProgramAssoc':isProgramAssocSpecialty(item)}]">
                                        {{item.text}}   
                                    </v-list-item-title>
                                </v-list-item-content>                                
                            </template>
                        </v-autocomplete>

                    </v-flex>                                  
                    
                    <!-- Email -->
                    <v-flex xs12 sm5>
                        <p :class="$style.registerLabel">
                            <str index="form > email"/><sup>*</sup>
                        </p>
                        <v-text-field 
                            @keyup="lowerCase('user_data.email' , user_data.email)" 
                            :class="['registerInput',
                                    $style.inputField]" 
                                    outlined 
                                    dense
                                    background-color="white"
                                    v-model='user_data.email' 
                                    validate-on-blur 
                                    :rules="formRules().validEmail">    
                            <template v-slot:message="{ message }">
                                <str :index="message" />
                            </template>
                        </v-text-field>
                    </v-flex>

                    <!-- Confirm email -->
                    <v-flex xs12 sm5>
                        <p :class="$style.registerLabel">
                            <str index="form > confirm_email"/><sup>*</sup>
                        </p>
                        <v-text-field 
                            @keyup="lowerCase('confirm.email', confirm.email)" 
                            :class="['registerInput',
                                    $style.inputField]" 
                            outlined 
                            dense
                            background-color="white"
                            autocomplete="new-password"
                            id="confirmEmail"
                            :rules="formRules(user_data.email, user_data.password).validConfirmEmail"
                            v-model='confirm.email'>
                            <template v-slot:message="{ message }">
                                <str :index="message" />
                            </template>
                        </v-text-field>
                    </v-flex>

                    <!-- Password -->
                    <v-flex xs12 sm5>
                        <p :class="$style.registerLabel">
                            <str index="form > password"/><sup>*</sup>
                        </p>
                        <v-text-field 
                            :class="['registerInput',
                                    $style.inputField]" 
                            :type="config.passwordType" 
                            outlined 
                            background-color="white"
                            v-model='user_data.password' 
                            :rules="formRules().validPassword">
                            <v-icon small style="margin-top: 15%" slot="append" @click="togglePasswordType('passwordType')" 
                                v-if="config.passwordType != 'password'">fa-eye</v-icon>
                            <v-icon small style="margin-top: 15%" slot="append" @click="togglePasswordType('passwordType')" v-else>
                                fas fa-eye-slash
                            </v-icon>
                            <template v-slot:message="{ message }">
                                <str :index="message" />
                            </template>
                        </v-text-field>
                    </v-flex>

                    <!-- Confirm Password -->
                    <v-flex xs12 sm5>
                        <p :class="$style.registerLabel">
                            <str index="form > confirm_password"/><sup>*</sup>
                        </p>
                        <v-text-field
                            :class="['registerInput',
                                    $style.inputField]" 
                            :type="config.confirmPasswordType" 
                            background-color="white"
                            outlined 
                            v-model='confirm.password'
                            id="confirmPassword"
                            :rules="formRules(user_data.email, user_data.password).validConfirmPassword">
                            <v-icon small style="margin-top: 15%" slot="append" @click="togglePasswordType('confirmPasswordType')" 
                                v-if="config.confirmPasswordType != 'password'">fa-eye</v-icon>
                            <v-icon small style="margin-top: 15%" slot="append" @click="togglePasswordType('confirmPasswordType')" v-else>
                                fas fa-eye-slash
                            </v-icon>
                            <template v-slot:message="{ message }">
                                <str :index="message" />
                            </template>
                        </v-text-field>
                    </v-flex>
                    
                    <!-- casl consent -->
                    <v-row justify="center" align="center" id="casl-consent-checkbox-container">
                        <v-col cols="10" class="pa-0 align-baseline caption">
                            <v-checkbox
                                v-model="user_data.casl_marketing"
                                value="Y">
                                <template v-slot:label>
                                    <str class="caption grey--text text--darken-4" index="form > consent_register marketing"/>
                                </template>
                                <template v-slot:message="{ message }">
                                    <str :index="message" />
                                </template>                                
                            </v-checkbox>
                        </v-col>
                    </v-row>
                    
                    <!-- terms and policy consent -->
                    <v-row justify="center" align="center" id="term-policy-checkbox-container">
                        <v-col cols="10" class="pa-0 align-baseline caption">
                            <v-checkbox
                                v-model="terms_policy_consent"
                                :rules="formRules().validTermPolicyConsent"
                                value="Y">
                                <template v-slot:label>
                                    <span class="grey--text text--darken-4">
                                    <str class="caption" index="form > consent_register acknowledge_part_1"/>&nbsp;
                                    <a href='#' @click="$emit('site_regulation', 'terms_of_use')">
                                        <str class="caption" index="form > vivomap terms"/>
                                    </a>&nbsp;
                                    <str class="caption" index="form > consent_register acknowledge_part_2"/>&nbsp;
                                    <a href='#' @click="$emit('site_regulation', 'privacy_policy')">
                                        <str class="caption" index="form > vivomap privacy_policy"/>
                                    </a>
                                    </span>
                                </template>
                                <template v-slot:message="{ message }">
                                    <str :index="message" />
                                </template>                                  
                            </v-checkbox>
                        </v-col>
                    </v-row>                    
                    
                    <v-flex xs10 :class="$style.signBtnSection" mt-3>
                        <v-btn depressed rounded :color="!validated ? '#d3d3d3':'#1c94ec'" :dark="validated" :class="$style.signUpBtn" @click="validateRegister">
                            <str index="button > sign_up"/>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
            <button></button>
        </v-form>
    </v-card>
</template>

<script>
import SpecialtyList from '@/plugins/SpecialtyList.js';
import CanadaProvinceFrenchTranslation from '@/plugins/CanadaProvinceFrenchTranslation.js'
import _cloneDeep from 'lodash/cloneDeep';

export default {
    name: 'userFormRegister',
    props: {
        user: {
            type: Object,
            required: false
        },
        programId : {
            type: Number,
            required: false
        },
        userEmail: {
            type: String, 
            required: false
        }
    },
    mounted: function(){
        this.init();
    },
    beforeUpdated: function() {
        this.$refs.userFormRegister.reset();
    },
    data: function(){
        return {
            valid: {
                userForm: false
            },
            user_data: null,
            new_password: false,
            new_email: false,            
            confirm: {
                password: null,
                email: null
            }, 
            geoAPI : null,    
            config: {
                passwordType: "password",
                confirmPasswordType: "password"
            },
            validated: false,
            terms_policy_consent: null,
            programAssocSpeciatyList: [],
            programNotAssocSpecialtyList: []
        }
    },
    methods: {
        init: function(){
            this.user_data = this.user ? this.unlink(this.user) : this.userTemplate();
            if(this.user_data.id){
                this.confirm.email = this.user_data.email
            }
            this.user_data.password = null;
            this.geoAPI = this.countrycitystatejson(); //require('countrycitystatejson');
            
            // lets anchor/stick to English terms so programAssocSpeciatyList will be consistent across langs
            // Notice: programNotAssocSpecialtyList after mapping will be same as source and will have Eng. term under text attr, and label_key is label/term index at dictionary
            let self = this;
            this.programNotAssocSpecialtyList = _cloneDeep(SpecialtyList).map((specialty) => {
                //this "IF" cond handles odd scenario when term label does not exist in labels DB table
                if (self.$store.getters.library.labels[specialty.text]!==undefined){
                    specialty['label_key'] = specialty.text;
                    specialty.text = self.$store.getters.library.labels[specialty.text]['en'];
                    return specialty;
                }
            });

            // Adding program related specialties to programAssocSpecialtyList while reducing those from programNotAssocSpecialtyList
            for(let s=0; s<self.programSpecialtyList.length; s++){
                let specialtyWords = self.programSpecialtyList[s].split(" ");
                for(let swInx=0; swInx<specialtyWords.length; swInx++){
                    if (specialtyWords[swInx].length==1 || specialtyWords[swInx].toLowerCase()==='general' || specialtyWords[swInx].toLowerCase()==='other'){
                        continue;
                    }
                    for(let i=0; i<self.programNotAssocSpecialtyList.length; i++){
                        //this "IF" handles odd scenario when term label does not exist in labels DB table
                        if (self.programNotAssocSpecialtyList[i]===undefined){
                            self.programNotAssocSpecialtyList.splice(i, 1);
                            continue;                        
                        }
                        let needle = specialtyWords[swInx].length >=5 ? specialtyWords[swInx].toLowerCase().slice(0, -1) :  specialtyWords[swInx].toLowerCase();
                        let index = self.programNotAssocSpecialtyList[i].text.toLowerCase().includes(needle);
                        if (index===true) {
                            self.programAssocSpeciatyList.push(self.programNotAssocSpecialtyList[i]);
                            continue;
                        }                   
                    }
                }
            }            
            
        },
        userTemplate: function(){
            return {
                firstname: null,
                lastname: null,
                email: this.userEmail ? this.userEmail : null,
                password: null,
                address: null,
                country: null,
                city: null,
                province: null,
                postalcode: null,
                language: null,
                type: 'user',
                specialty: null,
                notes: null,
                active: 'Y',
                validated: null,
                casl_marketing: null
            }
        },              
        lowerCase: function(target , data){
            data = data ? data.toLocaleLowerCase() : ""; 
            eval("this."+target+" = '"+data+"'");
        },
        upperCase: function(target , data){
            data = data ? data.toLocaleUpperCase() : "";
            eval("this."+target+" = '"+data+"'");
        },
        proper: function(target , data) {
            data = sentenceCase(data);
            eval("this."+target+" = '"+data+"'");

            function sentenceCase (str) {
                str = str ? str.toString() : "";

                return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
            }
        },
        save: function(){
            return new Promise(resolve => {
                this.user_data.language = this.$language();
                this.$emit('save', {
                    user: this.user_data, 
                    new_password: this.new_password, 
                    new_email: this.new_email,
                    target_program: this.programId,
                    validation_state: this.$refs.userFormRegister.validate()
                });
                resolve("saved");
            })
            
        },
        validateRegister: function() {
            var self = this;
            if (this.$refs.userFormRegister.validate()) {
                this.validated = true;
                this.save().then(function() {
                    self.$refs.userFormRegister.reset();
                });
            } else {
                this.validated = false;
                if (!this.user_data.email) {
                    this.$refs.userFormRegister.inputs.filter(element => element.id == 'confirmEmail')[0].reset()
                }
                if(!this.user_data.password) {
                    this.$refs.userFormRegister.inputs.filter(element => element.id == 'confirmPassword')[0].reset()
                }
                
            }
        },
        togglePasswordType: function(typePw){
            this.config[typePw] = this.config[typePw]=='password' ? 'text' : 'password';
        },
        isProgramAssocSpecialty: function(specialtyOption){
            return this.programAssocSpeciatyList.filter(elem => elem.value===specialtyOption.value).length > 0
        }
    },
    computed: {
        programSpecialtyList: function(){
            let self = this;
            let list = []
            if (this.programId){
                let programSpecialty = this.$store.getters.programs.filter((program)=> {
                    if (program.id==self.programId) {
                        return program.specialty.map(elem => list.push( elem['en'] ));
                    }
                });               
            }
            
            return list;
        },        
        list_countries: function(){
            var geoAPI = this.geoAPI;
            var countries = geoAPI.getCountries();

            var list = [];
            for(let i in countries){
                var record = countries[i];
                list.push({
                    text: record.native,
                    value: record.shortName
                });
            }
            
            return list;
        },
        list_states: function(){
            if(this.user_data.country) {
                var geoAPI = this.geoAPI;
                var states = geoAPI.getStatesByShort(this.user_data.country);
                let result = [];
                for (let i =0; i < states.length; i++) {
                    if((this.user_data.country  === "CA" || this.user_data.country === "Canada") && this.$language() === "fr") {
                        result.push({
                            text: CanadaProvinceFrenchTranslation[states[i]],
                            value: states[i]
                        });
                    } else {
                        result.push({
                            text: states[i],
                            value: states[i]
                        });
                    }
                }
                return result
            } 
            return [];
        },
        // list_hcp_job_profession: function(){
        //     let needle = "list_hcp_job_profession > "
        //     let hcpJobProfessionLabelKeys = Object.keys(this.$store.getters.library.labels).filter(key => key.includes(needle))
        //     let hcpJobProfessionList = []
        //     let otherProfessionIndex = null
        //     for(let key in hcpJobProfessionLabelKeys){
        //         let value = this.$store.getters.library.labels[hcpJobProfessionLabelKeys[key]]['en']
        //         if (value==='Other'){
        //            otherProfessionIndex = key; 
        //         }
        //         hcpJobProfessionList.push({"text": this.labels(hcpJobProfessionLabelKeys[key]), "value":value})
        //     }
        //     let otherProfessionItem = hcpJobProfessionList.splice(otherProfessionIndex, 1)
        //     return [...hcpJobProfessionList, ...otherProfessionItem] 
        // },
        // list_specialty: function() {
        //     let self = this;
        //     let programNotAssocSpecialtyList = self.programNotAssocSpecialtyList.map((specialty) => {
        //         return {
        //             text: self.labels(specialty.label_key),
        //             value: specialty.value
        //         };
        //     });                      
        //     programNotAssocSpecialtyList.sort(function(a,b) {
        //         if(a.text < b.text) {return -1;}
        //         if(a.text > b.text) {return 1;}
        //         return 0;
        //     });
            
        //     let programAssocSpeciatyList = self.programAssocSpeciatyList.map((specialty) => {
        //         return {
        //             text: self.labels(specialty.label_key),
        //             value: specialty.value
        //         };
        //     });                      
        //     programAssocSpeciatyList.sort(function(a,b) {
        //         if(a.text < b.text) {return -1;}
        //         if(a.text > b.text) {return 1;}
        //         return 0;
        //     });
            
        //     return [...programAssocSpeciatyList, ...programNotAssocSpecialtyList];
        // },
        list_hcp_job_profession: function() {
            let Language = this.$language()
            let List = this.$store.getters.specialties
            let Labels =  this.$store.getters.library.labels
            let output = [];
            for(let Key in List){
                let Label = Labels[`list_hcp_job_profession > ${Key}`] ? Labels[`list_hcp_job_profession > ${Key}`][Language] : `list_hcp_job_profession > ${Key}`
                output.push({
                    text: Label,
                    value: Key
                })
            }
            output.sort(function(a,b) {
                if(a.text < b.text) {return -1;}
                if(a.text > b.text) {return 1;}
                return 0;
            })
            return output;
        },
        list_specialty: function() {
            let output = []
            let hcp_job_profession = this.user_data.hcp_job_profession
            if(hcp_job_profession){
                let List = this.$store.getters.specialties[hcp_job_profession]
                let Language = this.$language()
                let Associated = []
                let Unassociated = []
                for(let i=0; i<List.length; i++){
                    let item = List[i]
                    if(this.isProgramAssocSpecialty(item)){
                        Associated.push({
                            text: item.label[Language],
                            value: item.value
                        })
                    }else{
                        Unassociated.push({
                            text: item.label[Language],
                            value: item.value
                        })                        
                    }
                }

                Associated.sort(function(a,b) {
                    if(a.text < b.text) {return -1;}
                    if(a.text > b.text) {return 1;}
                    return 0;
                })

                Unassociated.sort(function(a,b) {
                    if(a.text < b.text) {return -1;}
                    if(a.text > b.text) {return 1;}
                    return 0;
                })

                output = [...Associated, ...Unassociated]
                
            }

            return output
        }, 
        list_user_types: function(){
            var list = [
                {text:'user' , value:'user'},
                {text:'client' , value:'client'},
                {text:'staff' , value:'staff'},
                {text:'admin' , value:'admin'},
                {text:'rep' , value:'rep'}       
            ];
            return list;
        },
        
        list_languages: function(){
            var list = [];

            for(let i in this.$store.getters.library.languages){
                list.push({
                    text: i,
                    value: i
                })
            }

            return list;
        },

        message_invalid_email: function(){
            return this.$store.getters.library.labels['messages > invalid email'][this.$language()];
        },

        message_invalid_password: function(){
            return this.$store.getters.library.labels['messages > invalid password'][this.$language()];
        },

        message_weak_password: function(){
            return this.$store.getters.library.labels['messages > weak password'][this.$language()];
        },

        allow: function(){
            return this.$store.getters.user && this.$store.getters.user.type=='admin';
        },
        userDataPassword: function(){
            return this.user_data && this.user_data.password ? this.user_data.password.length : 0;
        }
    },
    watch: {
        userDataPassword: function(after, before){
            if( after !== before ){
                this.confirm.password = null;
            }
        },
        'valid.userForm': {
            handler: function(after, before) {
                if(after && !before) {
                    this.validated = true;
                } else {
                    this.validated = false;
                }
            },
            deep: true
        }
    }
}
</script>

<style module>
.userFormMain{
    position: relative;
    margin: 4% auto 0;
    background-color: transparent !important;
}

.userFormMainFr {
    margin: 7% auto 0;
}

.registerLabel {
    margin-bottom: 0px !important;
    margin-left: 0.5%;
    color: black;
    font-size: 12pt;
    font-weight: 400;
} 
.registerLabel sup {
    color: red;
    margin-left: 1px;
}

.userFormMain .inputField{
    /* display: inline-block; */
    width: 100%;
    /* margin: 5px; */
    font-size: 12px !important;
}

.confirmed input{
    color: green !important;
}
.failed input{
    color: red !important;
}

.termPolicyContent {
    color: black;
    font-size: 12pt;
    font-weight: 400;
    width: 91%;
    margin: 0 auto;
}

.signBtnSection {
    padding-bottom: 10%; 
    text-align: center;
}

.signUpBtn {
    text-transform: initial !important;
    padding: 0% 5% !important;
}
</style>

<style lang="scss" scroped>
.v-text-field--outlined fieldset {
    top: -8px !important;
}

.registerInput .v-input__control .v-input__slot {
    min-height: auto !important;
}

.registerInput .v-input__control .v-select__slot {
    height: 33px;
}

.registerInput .v-input__control .v-select__slot .v-input__append-inner {
    margin-top: 4px !important;
}

.registerInput .v-input__control .v-input__slot .v-input__append-inner {
    margin-top: 5px !important;
}

.registerInput .v-input__control .v-text-field__details .v-messages {
    color: #ff5252;
}

.specialtyProgramAssoc {
    font-weight: 900 !important;
    color: lightseagreen;
}
</style>

<style>
#sign-up-container .v-icon.v-icon {
    font-size: 15px !important;
}

#sign-up-container .v-input--selection-controls__input {
    width: 14px;
    color: transparent;
}

#sign-up-container .v-input--selection-controls {
    margin-top: 0;
}

#sign-up-container .v-input--selection-controls .v-input--selection-controls__input:hover .v-input--selection-controls__ripple:before{
    background: transparent;
}

#term-policy-checkbox-container .v-input__slot,
#casl-consent-checkbox-container .v-input__slot
{
    align-items: inherit;
}

#term-policy-checkbox-container .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot,
#casl-consent-checkbox-container .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot
{
    margin-bottom: 1px;
}
</style>